import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from 'src/app/models/create-result';
import { CustomServicesConfigModel } from 'src/app/models/custom-service-config-mode';
import { MerchantDTViewModel } from 'src/app/models/merchant-dt-view-model';
import { ParticipantViewModel } from 'src/app/models/participant-view-model';
import { ServiceModel } from 'src/app/models/service-model';
import { ServiceParameterModel } from 'src/app/models/service-parameter-model';
import { CustomConfigService } from 'src/app/services/custom-config.service';
import { PermissionEnum } from 'src/app/services/guards/permissions';
import { MerchantService } from 'src/app/services/merchant.service';
import { ParticipantService } from 'src/app/services/participant.service';
import { ServiceParameterService } from 'src/app/services/service-parameter.service';
import { ServiceService } from 'src/app/services/service.service';
import { UserDataStoreService } from 'src/app/services/user-data-store.service';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { ApiKeyComponent } from '../api-key-view/api-key-view.component';
import { ServiceEditComponent } from '../service-edit/service-edit.component';
import { ServiceParameterEditComponent } from '../service-parameter-edit/service-parameter-edit.component';
import { DataTablesResponseViewModel } from 'src/app/models/data-tables-response-view-model';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-custom-services-setup',
  templateUrl: './custom-services-setup.component.html',
  styleUrls: ['./custom-services-setup.component.scss']
})
export class CustomServicesSetupComponent implements OnInit {
  @ViewChild('merchantSelect') merchantSelect: NgSelectComponent;
  @ViewChild('servicesSelect') servicesSelect: NgSelectComponent;
  @ViewChild('parameterService') parameterService: NgSelectComponent;
  @ViewChild(DataTableDirective) public dtElement: DataTableDirective;

  public merchants: MerchantDTViewModel[];
  public services: ServiceModel[];
  public customServices: CustomServicesConfigModel[];
  public customService: CustomServicesConfigModel;
  public participant: ParticipantViewModel;
  public createResult: CreateResult;
  public canEdit: boolean;
  public participantID: number;
  public selectedMerchant: number;
  public selectedService: number;
  public allServices: ServiceModel[];
  public unlinkedServices: ServiceModel[];
  public serviceParameters: ServiceParameterModel[];
  public serviceInput: string = '';
  public serviceParameterInput: string = '';
  public linkedService: number;
  public apiKey: string;
  public buttonStatus: string;
  public updateAllMerchants = false;
  public dtTrigger: Subject<boolean> = new Subject();
  private searchEndpoint = `${environment.apiUrl}/api/customService/Search`;

  constructor(
    private _httpClient: HttpClient,
    private _participantService: ParticipantService,
    private _customServicesService: CustomConfigService,
    private _serviceParameterService: ServiceParameterService,
    private _merchantService: MerchantService,
    private _serivceService: ServiceService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _modalService: NgbModal,
    private cdref: ChangeDetectorRef) { }

  public async ngOnInit(): Promise<void> {
    let participant = localStorage.getItem('selectedParticipant');

    if (participant !== '') {
      this.participantID = JSON.parse(participant).id;
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
      await this.initParticipant(this.participantID);
      await this.initMerchants();
      await this.initServices();
      await this.initLinkedServices();
      await this.initServiceParameters();
      if (!this.canEdit) {
        this.buttonStatus = "display:none";
      }
    }
  }

  public async ngAfterViewInit(): Promise<void> {
    this.dtTrigger.next();
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public async initMerchants(): Promise<void> {
    this.merchants = await this._merchantService.GetAllMerchants();
  }

  public async initServices(): Promise<void> {
    this.allServices = await this._serivceService.GetServices();
  }

  public async initLinkedServices(): Promise<void> {
    let services = await this._serivceService.GetServices();
    let serviceParameters = await this._serviceParameterService.GetAllServiceParameters();
    let linkedServices: ServiceModel[] = [];

    serviceParameters.forEach(x => {
      linkedServices.push(x.service);
    })

    this.unlinkedServices = services.filter(ar => !linkedServices.find(rm => (rm.id === ar.id)));
  }

  public async initServiceParameters(): Promise<void> {
    this.serviceParameters = await this._serviceParameterService.GetAllServiceParameters();
  }

  public columns: any[] = [
    { data: 'merchantNumber', title: 'Merchant', visible: true, searchable: true, search: { value: '', regex: true } },
    { data: 'service', title: 'Service', visible: true, searchable: true, search: { value: '', regex: true } },
    { data: 'apiKey', title: 'API Key', visible: true, searchable: true, search: { value: '', regex: true } },
  ];

  private searchColumns = this.columns.map((col) => {
    if (!!col.search) {
      return { search: col.search.value, regex: col.search.regex };
    } else {
      return null;
    }
  });

  public dtOptions: DataTables.Settings = {
    pageLength: 10,
    serverSide: true,
    processing: true,
    ajax: (dataTablesParameters: any, callback) => {
      this._httpClient
        .post<DataTablesResponseViewModel>(
          `${this.searchEndpoint}/${this.participantID}`,
          dataTablesParameters, {}
        ).subscribe(result => {
        this.customServices = result.data;
        callback({
          recordsTotal: result.recordsTotal,
          recordsFiltered: result.recordsFiltered,
          data: []
        });
      });
    },
    columns: this.columns,
    searchCols: this.searchColumns
  };

  private async reloadData(): Promise<void> {
    
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload()
    });
  }

  public async getServices(event: any): Promise<void> {
    if (event !== 0) {
      this.selectedMerchant = event;
      let services = await this._serivceService.GetServices();
      let merchantServices = this.customServices.filter(x => x.merchantNumber === event);
      this.services = services.filter(ar => !merchantServices.find(rm => (rm.service.id === ar.id)));
    }
  }

  public async setUpdateAllMerchants(event: any) {
    if (event !== null) {
      if (event.target.checked) {
        this.updateAllMerchants = true;
        this.services = await this._serivceService.GetServices();
      } else {
        this.updateAllMerchants = false;
        this.services = [];
      }
    }
  }

  public selectService(event: number) {
    this.selectedService = event;
  }

  public linkServiceChange(event: number) {
    this.linkedService = event;
  }

  public async addService(): Promise<void> {
    
    if (this.selectedMerchant !== undefined && this.selectedService !== undefined && this.updateAllMerchants === false) {
      const customService: CustomServicesConfigModel = {
        id: 0,
        participantId: this.participantID.toString(),
        merchantNumber: this.selectedMerchant.toString(),
        apiKey: this.apiKey.toString(),
        shortApiKey: '',
        service: {
          id: Number(this.selectedService),
          name: this.services.filter(x => x.id === Number(this.selectedService)).map(x => x.name)[0]
        }
      };

      const result = await this._customServicesService.AddCustomService(customService);
      if (result.success) {
        await this.reloadData();
        this.clearDropDowns();
      }
      return;
    }

    if (this.selectedService !== undefined && this.updateAllMerchants) {
      const services: CustomServicesConfigModel[] = [];
      this.merchants.forEach(merchant => {
        const customService: CustomServicesConfigModel = {
          id: 0,
          participantId: this.participantID.toString(),
          merchantNumber: merchant.merchantNumber,
          apiKey: this.apiKey.toString(),
          shortApiKey: '',
          service: {
            id: Number(this.selectedService),
            name: this.services.filter(x => x.id === Number(this.selectedService)).map(x => x.name)[0]
          }
        };
        services.push(customService);
      });

      const result = await this._customServicesService.AddCustomServiceBulk(this.participantID, services);
      if (result.success) {
        await this.reloadData();
        this.clearDropDowns();
      }
      return;
    }

    this._toastService.error('Please select both a merchant and service', 'Error');
  }

  public async addNewService(): Promise<void> {
    if (this.serviceInput.trim() !== '') {
      let service: ServiceModel = {
        id: 0,
        name: this.serviceInput
      };
      let result = await this._serivceService.AddService(service);
      if (result.success) {
        this.initServices();
        this.initLinkedServices();
        this.serviceInput = '';
      }
    } else {
      this._toastService.error('Please enter a valid name for the new service', 'Error');
    }
  }

  public async removeService(id: number): Promise<void> {
    let result = await this._serivceService.DeleteService(id);
    if (!result.success) {
      this._toastService.error(result.message, 'Error');
      return;
    }
    this.initServices();
    this.initLinkedServices();
  }

  public async addServiceParameter(): Promise<void> {
    if (this.serviceParameterInput.trim() !== '') {
      if (this.linkedService !== undefined) {
        let serviceParameter: ServiceParameterModel = {
          id: 0,
          name: this.serviceParameterInput,
          service: {
            id: Number(this.linkedService),
            name: this.unlinkedServices.filter(x => x.id === Number(this.linkedService)).map(x => x.name)[0]
          }
        };
        let result = await this._serviceParameterService.AddService(serviceParameter);
        if (result.success) {
          this.serviceParameterInput = '';
          this.initServiceParameters();
          this.initLinkedServices();
          this.clearDropDowns();
        }
      } else {
        this._toastService.error('Please select a service', 'Error');
      }
    } else {
      this._toastService.error('Please enter a valid name for the new service parameter', 'Error');
    }
  }

  public async editServiceParameter(id: number) {
    const modalRef = this._modalService.open(ServiceParameterEditComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.parameterId = id;
    await modalRef.result;
    await this.initLinkedServices();
    await this.initServiceParameters();
  }

  public async removeServiceParameter(id: number): Promise<void> {
    let result = await this._serviceParameterService.DeleteServiceParameter(id);
    if (!result.success) {
      this._toastService.error(result.message, 'Error');
      return;
    }
    this.initServiceParameters();
    this.initLinkedServices();
  }

  public async editService(entryId: number) {
    const modalRef = this._modalService.open(ServiceEditComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.serviceId = entryId;
    await modalRef.result;
    await this.initServices();
    await this.initServiceParameters();
    await this.reloadData();
  }


  public async deleteService(serviceId: number, merchantNumber: string) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });

    let HasMerchantService = await this._merchantService.HasMerchantService(merchantNumber, serviceId);
    if (HasMerchantService === false) {
      dialogRef.componentInstance.showCancel = true;
      dialogRef.componentInstance.acceptButtonText = 'Yes';
      dialogRef.componentInstance.cancelButtonText = 'No'
      dialogRef.componentInstance.title = 'Delete Custom Service'
      dialogRef.componentInstance.message = 'Are you sure you want to delete the selected Custom Service?'

      const result = await dialogRef.result;
      if (result) {
        await this._customServicesService.DeleteCustomService(merchantNumber, serviceId);
        await this.reloadData();
      }
    }
    else {
      dialogRef.componentInstance.showCancel = false;
      dialogRef.componentInstance.acceptButtonText = 'Close';
      dialogRef.componentInstance.title = 'Cannot Delete Custom Service'
      dialogRef.componentInstance.message = 'The selected Custom Service is linked to a mechant.'
    }
  }

  private clearDropDowns() {
    
    this.apiKey = "";
    this.updateAllMerchants = false;
    if (this.merchantSelect && this.merchantSelect.handleClearClick) {
      this.merchantSelect.handleClearClick();
    }
    if (this.servicesSelect && this.servicesSelect.handleClearClick) {
      this.servicesSelect.handleClearClick();
    }
    if (this.parameterService && this.parameterService.handleClearClick) {
      this.parameterService.handleClearClick();
    }
  }


  public async viewAPIKey(apikey: string): Promise<void> {
    const modalRef = this._modalService.open(ApiKeyComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static',
    }
    );
    modalRef.componentInstance.apikey = apikey;
    await modalRef.result;
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
